var button = {
    additionalInfo: 'AGREGAR DOCUMENTOS O COMENTARIOS',
    back: 'Atrás',
    cancel: 'Cancelar',
    cancelDispute: 'CANCELAR DISPUTA',
    cancelQuestionnaire: 'Sí, Cancelar Disputa',
    cancelThisDispute: 'CANCELAR ESTA DISPUTA',
    close: 'cerrar',
    delete: 'Sí, eliminar',
    done: 'completado',
    dontCancel: 'No, No Cancelar',
    getStarted: 'Comencemos',
    goBack: 'Volver',
    loadMore: 'CARGAR MÁS',
    neverMind: 'HE CAMBIADO DE OPINIÓN',
    next: 'Siguiente',
    nextQuestion: 'Siguiente Pregunta',
    noDelete: 'No, no eliminar',
    noDontDisputeIt: 'No, No Continuar con la Disputa',
    noExit: 'No, no salgas',
    noGoBack: 'NO, VOLVER',
    ok: 'ok',
    previousQuestion: 'Paso Anterior',
    redispute: 'SÍ, VOLVER A DISPUTAR LA TRANSACCIÓN',
    secureMessaging: 'IR A MENSAJERÍA SEGURA',
    submit: 'Entregar',
    submitDispute: 'Enviar la Disputa',
    tryAgain: 'Intentar de Nuevo',
    uploadDocuments: 'CARGAR DOCUMENTO',
    yesClose: 'Sí, cerrar',
    yesContinueDispute: 'Sí, Continuar con la Disputa',
    yesExit: 'Sí, salir'
};
export default button;
//# sourceMappingURL=button.js.map